
  import { Component, Emit, Prop } from 'vue-property-decorator'
  import { ImportStockView } from '@/components/config/importStock/ImportStockView'
  import SupervisorAddStockForm from '@/views/forms/custom/SupervisorAddStockForm.vue'

  @Component({
    components: { SupervisorAddStockForm },
  })
  export default class AddRecord extends ImportStockView {
    @Prop({ type: Boolean, default: false }) readonly isConfig!: boolean
    @Prop({ type: Boolean, default: false }) readonly value!: boolean
    @Prop({ type: Array, default: () => [] }) readonly existingRecords!: any[]
    @Prop({ type: Object, default: null }) readonly editRecord!: any
    @Prop({ type: Boolean, default: false }) readonly cleanForm!: boolean

    @Emit('input')
    cancel () {
      return false
    }

    @Emit('created')
    onCreated (formData) {
      return formData
    }

    @Emit('edited')
    onEdited (formData) {
      return formData
    }
  }
